"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineStream = exports.defineMethod = void 0;
// The helpers each methods/<domain>.ts defines its methods with, and the types that read a definition back.
const limits_js_1 = require("../protocol/limits.js");
// A fresh object with only the declared keys, so the runtime table holds exactly what the type says.
const toAccess = (access) => access.god === true ? { level: access.level, god: true } : { level: access.level };
const toMeta = (stream, options) => {
    var _a, _b, _c, _d;
    return ({
        access: toAccess(options.access),
        stream,
        maxConcurrent: (_a = options.maxConcurrent) !== null && _a !== void 0 ? _a : limits_js_1.DEVICE_MAX_CONCURRENT,
        timeoutMs: (_b = options.budgetMs) !== null && _b !== void 0 ? _b : limits_js_1.DEFAULT_TIMEOUT_MS,
        maxTimeoutMs: (_c = options.budgetMs) !== null && _c !== void 0 ? _c : limits_js_1.MAX_TIMEOUT_MS,
        deviceMaxDeadlineMs: (_d = options.budgetMs) !== null && _d !== void 0 ? _d : limits_js_1.DEVICE_MAX_DEADLINE_MS,
    });
};
// A request/response method: params P, result R; B is what a browser sends when the cloud fills fields in.
const defineMethod = (options) => toMeta(false, options);
exports.defineMethod = defineMethod;
// A method that emits chunks C before its result R; it runs until stopped, so it must name its budget.
const defineStream = (options) => toMeta(true, options);
exports.defineStream = defineStream;
